
/**
 * Genera y abre una ventana de impresión para un voucher de pedido interno.
 * @param {Object} order - Objeto del pedido principal (para datos de cliente/cabecera) o datos del pedido interno con cliente embebido.
 * @param {Array} items - Lista de items a imprimir.
 * @param {Object} options - Opciones adicionales (titulo, etc.)
 */
export const printInternalVoucher = (order, items, options = {}) => {
  if (!items || items.length === 0) return;

  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    console.error('No se pudo abrir la ventana de impresión');
    return;
  }

  const companyInfo = {
    name: 'TOPPING FROZEN SAS',
    nit: '90170185-0',
    address: 'CARRERA 7B# 26-29SUR, BOGOTA',
    phone: '+57 3224739150'
  };

  // Intentar resolver nombre cliente y numero pedido
  // En algunos contextos 'order' es el pedido padre Siigo, en otros es el pedido interno mismo via POS.
  const customerName = order.customer_name || order.client_name || order.client?.name || 'Cliente Particular';
  const orderNumber = order.order_number || order.id || 'N/A';
  const relatedId = order.related_external_order || order.parent_external_order || null;
  const date = new Date().toLocaleString('es-CO');

  // Calcular total
  const totalInternal = items.reduce((sum, item) => {
    const val = item.total || item.subtotal || (item.price * item.quantity) || 0;
    return sum + Number(val);
  }, 0);

  const itemsHtml = items.map(item => `
    <tr>
      <td style="padding: 4px 0; border-bottom: 1px dashed #eee;">${item.name}</td>
      <td style="padding: 4px 0; border-bottom: 1px dashed #eee; text-align: center;">${item.quantity}</td>
      <td style="padding: 4px 0; border-bottom: 1px dashed #eee; text-align: right;">$${Number(item.price || 0).toLocaleString('es-CO')}</td>
      <td style="padding: 4px 0; border-bottom: 1px dashed #eee; text-align: right;">$${Number(item.total || item.subtotal || (item.price * item.quantity) || 0).toLocaleString('es-CO')}</td>
    </tr>
  `).join('');

  const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Recibo Interno</title>
      <style>
        body { font-family: 'Courier New', monospace; padding: 20px; width: 300px; margin: 0 auto; }
        .header { text-align: center; margin-bottom: 20px; }
        .title { font-size: 16px; font-weight: bold; margin: 5px 0; }
        .info { font-size: 12px; margin-bottom: 15px; }
        table { width: 100%; border-collapse: collapse; font-size: 12px; }
        th { text-align: left; border-bottom: 1px solid #000; padding-bottom: 5px; }
        .total { margin-top: 15px; text-align: right; font-size: 14px; font-weight: bold; border-top: 1px solid #000; padding-top: 5px; }
        .footer { margin-top: 30px; text-align: center; font-size: 10px; }
        @media print {
          body { width: 100%; padding: 0; margin: 0; }
          .no-print { display: none; }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="title">${companyInfo.name}</div>
        <div style="font-size: 12px;">NIT: ${companyInfo.nit}</div>
        <div style="font-size: 12px;">${companyInfo.address}</div>
        <div style="font-size: 12px;">Tel: ${companyInfo.phone}</div>
      </div>

      <div class="info">
        <div><strong>Fecha:</strong> ${date}</div>
        <div><strong>Cliente:</strong> ${customerName}</div>
        <div><strong>Ref:</strong> ${orderNumber}</div>
        ${relatedId ? `<div><strong>Factura:</strong> ${relatedId}</div>` : ''}
      </div>

      <table>
        <thead>
          <tr>
            <th style="width: 40%">Prod</th>
            <th style="width: 15%; text-align: center;">Cant</th>
            <th style="width: 20%; text-align: right;">Unit</th>
            <th style="width: 25%; text-align: right;">Total</th>
          </tr>
        </thead>
        <tbody>
          ${itemsHtml}
        </tbody>
      </table>

      <div class="total">
        TOTAL A PAGAR: $${totalInternal.toLocaleString('es-CO')}
      </div>

      <div class="footer">
        <p>Gracias por su compra</p>
        <p>Este documento es un comprobante interno.</p>
      </div>

      <script>
        window.onload = function() { window.print(); window.close(); }
      </script>
    </body>
    </html>
  `;

  printWindow.document.write(htmlContent);
  printWindow.document.close();
};
